import React, { memo, useEffect } from 'react';
import { VoucherBanner } from './voucher';
import { setEventCookie } from './utils';
const CMessage = ({ component: Component = VoucherBanner, event, onClose: closeCallback, onRedeem: redeemCallback, onShow, track, trackEvents, ...props }) => {
    const { endDate, reusableCode, startDate, voucherCode } = event || {};
    const { closeEventName, showEventName, redeemEventName } = trackEvents || {};
    useEffect(() => {
        if (showEventName) {
            track === null || track === void 0 ? void 0 : track(showEventName);
        }
        onShow === null || onShow === void 0 ? void 0 : onShow(voucherCode);
    }, [onShow, showEventName, track, voucherCode]);
    const onClose = () => {
        const expires = setEventCookie(voucherCode, endDate, reusableCode);
        if (closeEventName) {
            track === null || track === void 0 ? void 0 : track(closeEventName);
        }
        closeCallback === null || closeCallback === void 0 ? void 0 : closeCallback(voucherCode, { start: new Date(startDate), end: expires });
    };
    const onRedeem = () => {
        setEventCookie(voucherCode, endDate, reusableCode);
        if (redeemEventName) {
            track === null || track === void 0 ? void 0 : track(redeemEventName);
        }
        redeemCallback(voucherCode, { voucherCode });
    };
    if (!event) {
        return null;
    }
    return React.createElement(Component, { ...props, event: event, onClose: onClose, onRedeem: onRedeem });
};
export const CommercialMessage = memo(CMessage);
//# sourceMappingURL=component.js.map